import VueCookies from 'vue-cookies'
import JwtDecode from 'jwt-decode'

export default {
  storePrincipal: (token) => {
    VueCookies.set('_auth', token, '1d')
  },
  getPrincipal: () => {
    return VueCookies.get('_auth')
  },
  getUserId: () => {
    return JwtDecode(VueCookies.get('_auth')).user
  },
  removePrincipal: () => {
    VueCookies.remove('_auth')
  }
}
